import PropTypes from "prop-types"
import { useRef } from "react"

import ProductAddons from "./product-addons"
import WizardActions from "./wizard-actions"
import WizardHeader from "./wizard-header"
import WizardOptions from "./wizard-options"

const MainBody = ({ outOfStockRef }) => {
  const wizardRef = useRef()

  return (
    <>
      <WizardHeader />
      <section ref={wizardRef}>
        <WizardOptions />
        <ProductAddons />
      </section>
      <div className="border-t-grey-10 tablet:border-none pt-18 pb-18 tablet:pt-16 tablet:pb-0 border-t">
        <WizardActions outOfStockRef={outOfStockRef} wizardRef={wizardRef} />
      </div>
    </>
  )
}

MainBody.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default MainBody
